import React from 'react';

const features = [
  {
    icon: 'fa-users',
    title: 'Real-Time Staff Coordination',
    description: 'The agent queries your on-site team via SMS during a live call and relays their answers to the caller. No other AI platform bridges digital and physical staff in real time.',
    highlight: true,
  },
  {
    icon: 'fa-exchange',
    title: 'Simultaneous Omnichannel',
    description: 'Voice, SMS, WhatsApp, email, and back-office communication happen concurrently — not sequentially. Your agent talks to a caller, texts a payment link, emails a confirmation, and messages staff — all in one interaction.',
    highlight: true,
  },
  {
    icon: 'fa-microphone',
    title: 'Takes Direction Like an Employee',
    description: 'Managers call or text the agent with instructions like "we\'re closed early tomorrow" and it updates business operations instantly. No dashboard required.',
    highlight: true,
  },
  {
    icon: 'fa-shield',
    title: 'Autonomous Operations',
    description: 'Every call is validated against quality checkpoints within 30 seconds. When a failure is detected, the platform traces the root cause, writes a fix, validates it through voice and text simulations, and deploys. Typically resolved in under 30 minutes without human intervention.',
    highlight: true,
  },
  {
    icon: 'fa-server',
    title: 'Dedicated Isolated Infrastructure',
    description: 'Every developer gets their own ECS container, Redis database, and DynamoDB tables. Consistent sub-800ms voice latency, scales to 300 simultaneous calls and 30k call-hours in a 3-hour window. Full data isolation — no noisy neighbors.',
  },
  {
    icon: 'fa-flask',
    title: 'Automated Regression Testing',
    description: 'Fully automated testing including real voice calls to assess and improve agent performance. Checkpoint validation ensures quality before every release.',
  },
  {
    icon: 'fa-magic',
    title: 'FAQ Optimizer',
    description: 'Automatically detects hallucinations, identifies missing knowledge, and generates a clear TODO list to improve your agent before deployment.',
  },
  {
    icon: 'fa-calendar',
    title: 'Calendar & Payments',
    description: 'Google Calendar integration with real-time availability. Stripe-powered in-call payment collection. The agent books, modifies, and collects deposits autonomously.',
  },
  {
    icon: 'fa-code',
    title: 'REST API & Developer Tools',
    description: '38 API endpoints, built-in playground, assistant studio, usage analytics, and call logs with full transcripts. Everything you need to build and iterate.',
  },
];

const Features = () => {
  return (
    <div id="features" className="px-8 py-20 bg-neutral-800">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="!text-white text-3xl lg:text-4xl font-bold font-['Montserrat'] mb-4">
            What Makes This Different
          </h2>
          <p className="!text-stone-300 text-lg font-medium font-['Inter'] max-w-3xl mx-auto">
            Not another chatbot wrapper. Your AI agent operates autonomously across voice, SMS, WhatsApp, email, and your back office — simultaneously.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className={`p-6 rounded-lg flex flex-col gap-4 transition-all ${
                feature.highlight
                  ? 'bg-gradient-to-br from-[#055EFD]/20 to-neutral-800 border border-[#055EFD]/30 hover:from-[#055EFD]/30 hover:to-neutral-700'
                  : 'bg-gradient-to-br from-neutral-700 to-neutral-800 hover:from-neutral-600 hover:to-neutral-700'
              }`}
            >
              <div className="w-12 h-12 bg-[#055EFD]/20 rounded-lg flex items-center justify-center">
                <i className={`fa ${feature.icon} text-[#0AF1FE] text-xl`}></i>
              </div>
              <div className="flex flex-col gap-2">
                <h3 className="!text-white text-lg font-bold font-['Montserrat']">{feature.title}</h3>
                <p className="!text-stone-300 text-sm font-medium font-['Inter'] leading-relaxed">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Features;
